<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Change Password</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Change Password</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="login-area pt-100 col-lg-3 mx-auto">
    <div class="container">
        <h2>Update Your Password</h2>

        <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
            <div *ngIf="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
            </div>
            <div class="form-group">
                <input type="password" class="form-control" placeholder="Current Password" formControlName="currentPassword">
                <div *ngIf="changePasswordForm.get('currentPassword').errors && changePasswordForm.get('currentPassword').touched" class="alert alert-danger">
                    Current password is required.
                </div>
            </div>

            <div class="form-group">
                <input type="password" class="form-control" placeholder="New Password" formControlName="newPassword">
                <div *ngIf="changePasswordForm.get('newPassword').errors && changePasswordForm.get('newPassword').touched" class="alert alert-danger">
                    New password is required and must be at least 6 characters.
                </div>
            </div>

            <div class="form-group">
                <input type="password" class="form-control" placeholder="Confirm Password" formControlName="confirmPassword">
                <div *ngIf="changePasswordForm.hasError('mismatch') && changePasswordForm.get('confirmPassword').touched" class="alert alert-danger">
                    Passwords do not match.
                </div>
            </div>

            <div class="text-center">
                <button type="submit" class="btn create-ac-btn" [disabled]="changePasswordForm.invalid">Change Password</button>
            </div>
        </form>
    </div>
</div>
